/** @jsx jsx */
import { jsx } from '@theme-ui/core';

import { useTranslation } from 'src/shared/translation';
import { getUserEventAttr } from 'src/shared/helpers/tracking-user-events';

import { ErrorMessage } from './error-message';
import { InputLabel } from './input-label';

export type TextInputProps = {
    id: string;
    type?: 'text' | 'password' | 'number' | 'email' | 'tel';
    label?: React.ReactNode;
    placeholder: string;
    value: string;
    onChange: JSX.IntrinsicElements['input']['onChange'];
    icon?: React.ReactNode;
    errorMessage?: React.ReactNode;
    userEvent?: string;
};

export const TextInput = ({
    label,
    placeholder,
    errorMessage,
    type = 'text',
    icon,
    userEvent = '',
    ...props
}: TextInputProps) => {
    const { t } = useTranslation();

    return (
        <div>
            {label && <InputLabel text={label} inputId={props.id} />}
            <div
                sx={{
                    position: 'relative',
                }}
            >
                <input
                    sx={{
                        width: '100%',
                        paddingX: 0,
                        paddingTop: '9px',
                        paddingBottom: '7px',
                        border: 'none',
                        borderBottom: 1,
                        borderColor: errorMessage ? 'whitelabel.failure' : 'grey.7',
                        outline: 'none',
                        backgroundColor: 'transparent',
                        paddingRight: icon ? 4 : null,
                        variant: 'text.body',
                        fontSize: 2,

                        '&:focus': {
                            borderColor: 'blue.primary',
                        },

                        '&::placeholder': {
                            variant: 'text.suggestion',
                            fontSize: 2,
                            fontWeight: 'normal',
                        },
                    }}
                    placeholder={t(placeholder)}
                    type={type}
                    {...getUserEventAttr(userEvent)}
                    {...props}
                />
                {icon && (
                    <span sx={{ position: 'absolute', right: 0, bottom: 1, paddingX: 2 }}>
                        {icon}
                    </span>
                )}
            </div>

            {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
        </div>
    );
};
